function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var WebWorkerTransport_1 = require('./src/Transport/WebWorkerTransport');
exports.WebWorkerTransport = WebWorkerTransport_1.WebWorkerTransport;
var WebSocketTransport_1 = require('./src/Transport/WebSocketTransport');
exports.WebSocketTransport = WebSocketTransport_1.WebSocketTransport;
var Client_1 = require('./src/Client');
exports.Client = Client_1.Client;
__export(require('./src/Client'));
//# sourceMappingURL=index.js.map